<template>
  <a-modal v-model:visible="modal.show" :footer="null"
           wrapClassName="modal_protocol" destroyOnClose>
    请先阅读并同意
    <a-button type="link" target="_blank"
              :href="$Config.Protocol.user">
      《用户注册协议》
    </a-button>
    <span>和</span>
    <a-button type="link" target="_blank"
              :href="$Config.Protocol.privacy">
      《隐私政策协议》
    </a-button>
    <!-- <span style="margin:0 -5px">和</span>
    <a-button type="link" target="_blank"
              :href="$Config.Protocol.disclaimers">
      《免责声明》
    </a-button> -->
    <div class="box_button">
      <a-space>
        <a-button @click="close">
          拒绝
        </a-button>
        <a-button type="primary"
                  @click="clickSure">
          同意
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'platform_modalProtocol',
  data(): DataInterface {
    return {
      modal: {
        show: false,
        callback: null
      }
    };
  },
  methods: {
    /**
     * 开启
     * @param {*} data 链接
     */
    async open(data: any): Promise<any> {
      this.modal.show = true;
      this.modal.callback = data.callback;
    },
    
    /**
     * 关闭
     */
    close(): void {
      this.modal.show = false;
      this.modal.callback = null;
    },
    
    /**
     * 点击确定
     */
    clickSure(): void {
      this.modal.callback?.();
      this.close();
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';

@image: '@{src_image}';

.modal_protocol {
  .ant-btn.ant-btn-link {
    padding: 0 5px;
  }
  
  .box_button {
    margin: 10px 0 0;
    text-align: right;
  }
}
</style>